/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '',
    // Relative to /src/views
    view: 'Home'
  },
  {
    path: '/login',
    name: 'login',
    view: 'Login'
  },
  {
    path: '/about',
    name: 'about',
    view: 'About'
  },
  {
    path: '/inventario',
    name: 'Inventário',
    view: 'Inventario'
  },
  {
    path: '/inventario/:objetoid',
    name: 'Detalhes Inventário',
    view: 'DetalhesInventario',
    props: true
  },
  {
    path: '/apresentacoes',
    name: 'Apresentações',
    view: 'Apresentacoes'
  },
  {
    path: '/apresentacoes/:apresentacaoid',
    name: 'Detalhes da Apresentação',
    view: 'DetalhesApresentacao',
    props: true
  },
  {
    path: '/apresentacoes/:apresentacaoid/edit',
    name: 'Editar Apresentação',
    view: 'EditarApresentacao',
    props: true
  },
  {
    path: '/adicionarapresentacao',
    name: 'Adicionar Apresentação',
    view: 'AdicionarApresentacao'
  },
  {
    path: '/repertorio',
    name: 'Repertório',
    view: 'Repertorio'
  },
  {
    path: '/repertorio/:repertorioid',
    name: 'Detalhes do Arranjo',
    view: 'DetalhesRepertorio',
    props: true
  },
  {
    path: '/repertorio/:repertorioid/edit',
    name: 'Editar Repertório',
    view: 'EditarRepertorio',
    props: true
  },
  {
    path: '/adicionararranjo',
    name: 'Adicionar Arranjo',
    view: 'AdicionarRepertorio'
  },
  {
    path: '/votacao',
    name: 'Votação de Repertório',
    view: 'Votacao'
  }
]
